export const getSessionToken = async () => {
	const clerk = window.Clerk;
	if (!clerk?.session) {
		return null;
	}
	return await clerk.session.getToken();
};
